// extracted by mini-css-extract-plugin
export default {"wrapper":"AddAdvert_wrapper__1aek5","flexColumn":"AddAdvert_flexColumn__rUzcA","flex":"AddAdvert_flex__q-Nuk","title":"AddAdvert_title__O+iCv"};